module.exports = __webpack_public_path__ + "img/USDT.ba1f3226.png";